import Button from "Components/Button";
import LoadingIcon from "Components/LoadingIcon";
import React, { Component } from "react";
import { Field, Form } from "react-final-form";
import { Metrics } from "Themes";
import { FormError } from "Themes/StyledComponents";
import { CommentButtonContainer, CommentContainer } from "./styles";

class CommentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formSubmitted: false
    };
    this.myRef = React.createRef();
  }

  render() {
    const { handleSubmit, fetching, commentError } = this.props;
    return (
      <Form
        onSubmit={handleSubmit}
        render={({ handleSubmit, form }) => (
          <form
            ref={this.myRef}
            onSubmit={async event => {
              await handleSubmit(event);
              form.reset();
            }}
          >
            <Field
              name={"comment"}
              render={props => {
                return (
                  <CommentContainer
                    {...props}
                    placeholder={"Comment here..."}
                    style={{
                      borderRadius: "5px",
                      border: Metrics.borders.secondaryBorder
                    }}
                  />
                );
              }}
            />
            {commentError && <FormError>There was an error</FormError>}
            <CommentButtonContainer>
              <Button type={"submit"}>
                {fetching ? <LoadingIcon /> : "Comment"}
              </Button>
            </CommentButtonContainer>
          </form>
        )}
      />
    );
  }
}

export default CommentForm;
